import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function AboutPage() {
  return (
    <MinimalPublicPage
      eyebrow="About Ouro"
      title="Cleaner CS starts with trust."
      description="Ouro exists for players who want accountable matchmaking without turning every solo queue into a gamble."
      points={[
        {
          title: "Verified players first",
          body: "Accounts are reviewed before joining the queue, so match quality starts before the server loads.",
        },
        {
          title: "Reputation matters",
          body: "Behavior and reliability shape the player pool over time, not just one match result.",
        },
        {
          title: "Built for serious players",
          body: "Small, focused queues beat anonymous lobbies when you care about the people on your team.",
        },
      ]}
      secondaryLabel="How it works"
      secondaryTo="/how-it-works"
    />
  );
}
